"use client"

import { formatAnalysisLastUpdated } from '@yeshuman/sdk'
import { RefreshCcw } from 'lucide-react'

import { SmartAnalysisRunButton } from './smart-analysis-run-button'

export type SmartAnalysisRunToolbarProps = {
  onClick: () => void
  isSearching: boolean
  disabled?: boolean
  lastUpdatedAt?: string | null
  className?: string
}

export function SmartAnalysisRunToolbar({
  onClick,
  isSearching,
  disabled = false,
  lastUpdatedAt,
  className,
}: SmartAnalysisRunToolbarProps) {
  const lastUpdatedLabel = formatAnalysisLastUpdated(lastUpdatedAt)

  return (
    <div className={className ?? 'flex w-full justify-end'}>
      <div className="flex flex-col items-end gap-1">
        <SmartAnalysisRunButton
          onClick={onClick}
          isSearching={isSearching}
          disabled={disabled}
          className="shrink-0"
        />
        {lastUpdatedLabel ? (
          <p className="flex items-center gap-1 text-xs text-muted-foreground">
            <RefreshCcw className="size-3 shrink-0" aria-hidden />
            <span>Last updated: {lastUpdatedLabel}</span>
          </p>
        ) : null}
      </div>
    </div>
  )
}
